import React, {useContext} from 'react';
import TruncatedText from '@core/scripts/components/truncated-text';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import {Price, Typography} from '@bonprix/design-system';
import {useBreakpointUp} from 'bonprix-design-system';

function AlpiInformation({title, onAlpiInformationClick, price}) {
    const {browser} = useContext(articleOverviewStaticContext);
    const breakpointXxlUp = useBreakpointUp('xxl');

    const renderAlpiTitle = () => {
        const oldBrowser = browser === 'IE';

        return (
            <div className="alpi__title" onClick={onAlpiInformationClick}>
                <TruncatedText className="alpi__truncated" oldBrowser={oldBrowser} lines={2}>
                    <Typography variant={'body1'} component="span" color="primary">
                        {title}
                    </Typography>
                </TruncatedText>
            </div>
        );
    };
    const renderAlpiPrice = () => {
        const getPriceVariant = () => {
            if (price.fallback) return 'no-price';
            if (price.bestPrice) return 'best-price';
            if (price.formerPrice) return 'sale';
            return 'regular';
        };

        return (
            <section className="alpi__price-wrapper" onClick={onAlpiInformationClick}>
                <Price
                    variant={getPriceVariant()}
                    currentPrice={price.value ? Number(price.value) : undefined}
                    size={breakpointXxlUp ? 'large' : 'small'}
                    amount={price.packItemsCount}
                    showUnits={price.packItemsCount > 1}
                    isFromPrice={!price.uniquePrice}
                    oldPrice={price.formerPrice ? Number(price.formerPrice.value) : undefined}
                />
            </section>
        );
    };

    return (
        <div className="alpi__article-information">
            {renderAlpiTitle()}
            {renderAlpiPrice()}
        </div>
    );
}

export default AlpiInformation;
